import { Component, Inject, Input, forwardRef, OnInit, ElementRef } from '@angular/core';
import { CardComponent } from './card/app.card.component';
declare var moment: any;

declare var $: any;
@Component({
    selector: 'app-select-day-modal-placeholder',
    templateUrl: './app.selectDayModal.component.html'
})

export class SelectDayModalComponent implements OnInit {



    element = null;
    day = 1;
    month = 1;
    year = 1396;
    Var = {

        days: [],
        monthes: [],
        years: [],
        monthesOfYear: [{
            id: 1,
            title: 'فروردین',
            days: 31
        }, {
            id: 2,
            title: 'اردیبهشت',
            days: 31
        }, {
            id: 3,
            title: 'خرداد',
            days: 31
        }, {
            id: 4,
            title: 'تیر',
            days: 31
        }, {
            id: 5,
            title: 'مرداد',
            days: 31
        }, {
            id: 6,
            title: 'شهریور',
            days: 31
        }, {
            id: 7,
            title: 'مهر',
            days: 30
        }, {
            id: 8,
            title: 'آبان',
            days: 30
        }, {
            id: 9,
            title: 'آذر',
            days: 30
        }, {
            id: 10,
            title: 'دی',
            days: 30
        }, {
            id: 11,
            title: 'بهمن',
            days: 30
        }, {
            id: 12,
            title: 'اسفند',
            days: 30
        }]
    }

    constructor( @Inject(forwardRef(() => CardComponent)) private cardCom: CardComponent, private el: ElementRef) {
        this.element = $(el.nativeElement);

    }






    changeMonth(event) {
        this.Var.days = [];
        for (let i = 1; i <= this.Var.monthesOfYear[this.month - 1].days; i++) {
          this.Var.days.push(i);
        }
      }
    onConfirmClick() {



        const d = this.year + '/' + this.month
            + '/' + this.day;
        const mm = moment(d, 'jYYYY/jM/jD');



        const date = {
            Year: this.year, Month: this.month, Day: this.day, DaysBefore: ((mm.day() + 8) % 7),
            DaysAfter: 6 - ((mm.day() + 8) % 7)
        }
        this.cardCom.handleSelectDay(date);

    }

    closeThisDialog(formCreds): void {
        this.cardCom.showCardModal = false;
    }

    getCurrentDay() {
        const m = moment();
        return m;
    }

    ngOnInit() {

        const parent = this.cardCom;
        this.element.on('click', function (e: any) {
            const target = $(e.target);

            if (!target.closest('.PopUpContainer').length) {

                parent.showSelectDayModal = false;
            }
        });



        const today = this.getCurrentDay();

        for (let i = 1; i <= this.Var.monthesOfYear['' + today.jMonth()].days; i++) {
            this.Var.days.push(i);
        }

        for (let i = today.jYear() - 5; i <= today.jYear() + 5; i++) {
            this.Var.years.push(i);
        }

        this.day = today.jDate();
        this.month = today.jMonth() + 1;
        this.year = today.jYear();

    }
}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.selectDayModal.component.ts